<template>
	<div class="mask">
		<div class="box">
			<img :src="obj.image" alt="" @click="gotoUrl" />
			<div class="close" @click.stop.prevent="closeEvent"></div>
			<!--<div class="btn_box"></div>-->
		</div>
	</div>
</template>

<script>
export default {
	name: 'frame',
	props: ['obj'],
	methods: {
		closeEvent() {
			this.$emit('close');
		},
		gotoUrl() {
			_hmt && _hmt.push(['_trackPageview', `/huoDong`]);
			this.closeEvent();
			location.href = this.obj.url;
		}
	}
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '../../common/style/config.less';
.mask {
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.7);
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1000;
}
.box {
	width: 10rem;
	height: 12.667rem;
	position: absolute;
	left: 50%;
	top: 50%;
	margin-left: -5rem;
	margin-top: -6.333rem;
}

.close {
	position: absolute;
	width: 0.720rem;
	height: 0.720rem;
	top: -0.933rem;
	right: 0.733rem;
	background: url('../../image/closexsq.png') no-repeat;
	background-size: 0.720rem 0.720rem;
}
.btn_box {
	position: absolute;
	bottom: 1.467rem;
	left: 1.280rem;
	width: 5.120rem;
	height: 1.280rem;
}
</style>



// WEBPACK FOOTER //
// frame.vue?24ce2ed3